import { render, staticRenderFns } from "./ListRole.vue?vue&type=template&id=7312ccf4&scoped=true&"
import script from "./ListRole.vue?vue&type=script&lang=js&"
export * from "./ListRole.vue?vue&type=script&lang=js&"
import style0 from "./ListRole.vue?vue&type=style&index=0&id=7312ccf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312ccf4",
  null
  
)

export default component.exports